import { ReactNode } from 'react'
import { usePermissions } from '~/entities/common/viewer'
import { canShowObject } from '~/shared/lib/utils'
import { Tab, Tabs } from '~/shared/ui/RoutesTabs/type'
import { CarDetailsPage } from './Details'
// import { EquipmentsPage } from './Equipments'
import {
  ListRentalContractPage,
  EditRentalContractPage,
} from './RentalContracts'

type UseConfigTabsProps = {
  documentsPage: ReactNode
}

export const useConfigTabs = ({ documentsPage }: UseConfigTabsProps): Tabs => {
  const { canRentalContractsView, canCarDocumentsView, canCarsView } =
    usePermissions()

  return [
    ...canShowObject<Tab>(canCarsView, {
      labelI18n: 'information',
      path: '/details',
      content: <CarDetailsPage />,
    }),
    ...canShowObject<Tab>(canCarDocumentsView, {
      labelI18n: 'documents',
      path: '/documents',
      content: documentsPage,
    }),
    ...canShowObject<Tab>(canRentalContractsView, {
      labelI18n: 'contracts',
      path: '/rental-contracts',
      content: <ListRentalContractPage />,
      children: [
        {
          path: '/:rentalContractId',
          content: <EditRentalContractPage />,
          full: true,
        },
      ],
    }),
    // {
    //   label: 'Комплектность',
    //   path: '/equipments',
    //   content: <EquipmentsPage />,
    // },
  ]
}
